module.exports = __webpack_public_path__ + "img/back-to-all-options.1f8929a7.svg";